let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dMRB2")).then(() => parcelRequire('15aZt'));